import React from 'react';
import { Sun, Waves, Umbrella, Calendar, Clock } from 'lucide-react';

const beachHours = [
  { day: 'Montag', hours: 'Ruhetag', isClosed: true },
  { day: 'Dienstag', hours: '16:30 – 22:00 Uhr' },
  { day: 'Mittwoch', hours: '16:30 – 22:00 Uhr' },
  { day: 'Donnerstag', hours: '16:30 – 22:00 Uhr' },
  { day: 'Freitag', hours: '16:30 – 23:00 Uhr' },
  { day: 'Samstag', hours: '14:00 – 23:00 Uhr' },
  { day: 'Sonntag', hours: '14:00 – 22:00 Uhr' },
];

const SaaleBeachSection = () => {
  return (
    <section id="beach-section" className="py-20 px-4" style={{ background: 'linear-gradient(to bottom, #1A0520, #0A0015)' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 animate-fade-in-up">
          <Sun className="w-12 h-12 mx-auto mb-4 animate-icon-float" style={{ color: '#FFD700', filter: 'drop-shadow(0 0 10px #FFD700)' }} />
          <h2 className="text-4xl md:text-5xl font-bold mb-4 px-6 py-2 inline-block animate-scale-in" style={{
            fontFamily: "'Great Vibes', cursive",
            color: '#FFFFFF',
            textShadow: '0 0 10px #FFFFFF, 0 0 20px #FFFFFF, 0 0 30px #FFFFFF',
            WebkitTextStroke: '1px black',
            paintOrder: 'stroke fill',
            background: '#FFFF00',
            boxShadow: '0 0 20px #FFFF00, 0 0 40px #FFFF00',
            borderRadius: '0.5rem',
            animation: 'neon-pulse 2s ease-in-out infinite, float 3s ease-in-out infinite'
          }}>
            Saale Beach
          </h2>
          <div className="h-1 w-24 mx-auto rounded-full" style={{ background: 'linear-gradient(to right, #FFD700, #FFA500)' }} />
          <p className="text-white/80 text-lg mt-6" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Entspannung am Wasser - Dein Sommer-Paradies in Hammelburg
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          {/* Image */}
          <div className="rounded-lg overflow-hidden shadow-2xl animate-fade-in-left delay-200 group">
            <img
              src="https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/1nmibt8u_Darker%20-%202026-03-29T171405.962.jpg"
              alt="Saale Beach"
              className="w-full h-full object-cover transition-transform duration-700"
              style={{
                animation: 'float 4s ease-in-out infinite, imageZoom 8s ease-in-out infinite'
              }} />

          </div>

          {/* Content */}
          <div className="flex flex-col justify-center animate-fade-in-right delay-300">
            <div className="glass-card p-8">
              <div className="space-y-6">
                {/* Willkommen */}
                <div>
                  <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif", color: '#FFD700' }}>
                    Willkommen am Hammelburger Saale Beach!
                  </h3>
                  <p className="text-white/80 leading-relaxed text-lg" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                    Genießen Sie den Sommer am Hammelburger Saale Beach, direkt an der Hammelburger Saale! Mit einem atemberaubenden Blick auf das Schloss Saaleck bieten wir Ihnen den perfekten Rückzugsort, um dem Alltag zu entfliehen und das Urlaubsfeeling in der Natur zu genießen.
                  </p>
                </div>

                {/* Kulinarische Vielfalt */}
                <div>
                  <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif", color: '#FFD700' }}>
                    Kulinarische Vielfalt
                  </h3>
                  <p className="text-white/80 leading-relaxed text-lg" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                    Unsere Speisekarte bietet eine breite Auswahl an köstlichen Gerichten, die für jeden Geschmack etwas bereithalten. Lassen Sie sich von unserer Auswahl an regionalen Weinen und einer bunten Palette an erfrischenden Cocktails verwöhnen. Für die kleinen Gäste haben wir ebenfalls gesorgt – Softdrinks und Eis dürfen hier natürlich nicht fehlen!
                  </p>
                </div>

                {/* Sonntag ist Kuchentag */}
                <div>
                  <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif", color: '#FFD700' }}>
                    Sonntag ist Kuchentag!
                  </h3>
                  <p className="text-white/80 leading-relaxed text-lg" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                    Genießen Sie an sonnigen Sonntagen unseren köstlichen Kaffee und leckere Kuchen in entspannter Atmosphäre. Bei uns wird der Sonntagsausflug zum besonderen Erlebnis!
                  </p>
                </div>

                {/* Entspannung pur */}
                <div>
                  <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif", color: '#FFD700' }}>
                    Entspannung pur
                  </h3>
                  <p className="text-white/80 leading-relaxed text-lg" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                    Die sandige Fläche und unsere bequemen Liegestühle laden dazu ein, sich zurückzulehnen und die Sonne zu genießen. Ideal für Familien, Freunde und Paare, die entspannende Stunden am Wasser verbringen möchten. Natürlich finden Sie auch auf unserer gemütlichen Terrasse Platz. Mit rund 300 Sitzplätzen ausgestattet mit Tischen und Stühlen laden wir Sie ein den Feierabend ausklingen zu lassen!
                  </p>
                </div>

                {/* Feiern und genießen */}
                <div>
                  <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif", color: '#FFD700' }}>
                    Feiern und genießen
                  </h3>
                  <p className="text-white/80 leading-relaxed text-lg" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                    Planen Sie eine Firmenfeier oder einen Geburtstag? Bei uns finden Sie einen separaten Bereich, ideal für Ihre Feierlichkeiten. Unsere Leidenschaft ist es, den Kunden den perfekten Sommer zu bescheren – bei uns wird jeder Besuch zu einem besonderen Erlebnis.
                  </p>
                </div>

                {/* Live Musik */}
                <div>
                  <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif", color: '#FFD700' }}>
                    Live Musik am Saale Beach! Dein unvergesslicher Sommer!
                  </h3>
                  <p className="text-white/80 leading-relaxed text-lg" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                    Was darf natürlich nicht fehlen? Live Musik und Events am Saale Beach. Checke unseren Event Kalender um keines unserer Events zu verpassen! Feiert mit uns die warmen Sommernächte und lasst uns den Sommer einzigartig machen!
                  </p>
                </div>
              </div>

              <div className="space-y-4 mt-6">
                <div className="flex items-center gap-3 animate-fade-in-right delay-400">
                  <Calendar className="w-6 h-6 animate-icon-bounce" style={{ color: '#FFD700' }} />
                  <span className="text-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    Events
                  </span>
                </div>
                <div className="flex items-center gap-3 animate-fade-in-right delay-500">
                  <Umbrella className="w-6 h-6 animate-icon-bounce" style={{ color: '#FFD700' }} />
                  <span className="text-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    Lounge
                  </span>
                </div>
                <div className="flex items-center gap-3 animate-fade-in-right delay-600">
                  <Sun className="w-6 h-6 animate-icon-pulse" style={{ color: '#FFD700' }} />
                  <span className="text-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    Sonnenterrasse
                  </span>
                </div>
                <div className="flex items-center gap-3 animate-fade-in-right delay-700">
                  <Waves className="w-6 h-6 animate-icon-float" style={{ color: '#FFD700' }} />
                  <span className="text-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    Beach Bar
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="glass-card p-6 text-center animate-scale-in delay-200">
            <Sun className="w-10 h-10 mx-auto mb-4 animate-icon-pulse" style={{ color: '#FFD700' }} />
            <h4 className="text-xl font-bold text-white mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
              Sommerzeit
            </h4>
            <p className="text-white/70 text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Von Mai bis September genießt du bei uns sonnige Tage am Wasser
            </p>
          </div>

          <div className="glass-card p-6 text-center animate-scale-in delay-300">
            <Umbrella className="w-10 h-10 mx-auto mb-4 animate-icon-float" style={{ color: '#FFD700' }} />
            <h4 className="text-xl font-bold text-white mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
              Lounge & Bar
            </h4>
            <p className="text-white/70 text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Entspannte Lounge-Atmosphäre mit erfrischenden Drinks direkt am Strand
            </p>
          </div>

          <div className="glass-card p-6 text-center animate-scale-in delay-400">
            <Calendar className="w-10 h-10 mx-auto mb-4 animate-icon-bounce" style={{ color: '#FFD700' }} />
            <h4 className="text-xl font-bold text-white mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
              Events
            </h4>
            <p className="text-white/70 text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Regelmäßige Beach-Events und besondere Veranstaltungen
            </p>
          </div>
        </div>

        {/* Öffnungszeiten Saale Beach */}
        <div className="mt-16 max-w-3xl mx-auto animate-fade-in-up" data-testid="beach-opening-hours">
          <div className="text-center mb-8">
            <Clock
              className="w-12 h-12 mx-auto mb-4 animate-icon-pulse"
              style={{ color: '#FFFF00', filter: 'drop-shadow(0 0 10px #FFFF00)' }}
            />
            <h3
              className="text-3xl md:text-4xl font-bold text-white mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Öffnungszeiten Saale Beach
            </h3>
            <div
              className="h-1 w-24 mx-auto rounded-full"
              style={{
                background: 'linear-gradient(to right, #FFFF00, #FFD700)',
                boxShadow: '0 0 15px #FFFF00',
              }}
            />
            <p
              className="text-white/70 text-sm mt-4"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Saisonal geöffnet von Mai bis September
            </p>
          </div>

          <div
            className="glass-card p-6 md:p-8"
            style={{
              border: '1px solid rgba(255, 255, 0, 0.25)',
              boxShadow: 'inset 0 0 30px rgba(255, 255, 0, 0.05)',
            }}
          >
            {beachHours.map((item) => (
              <div
                key={item.day}
                className={`flex justify-between items-center py-3 border-b border-yellow-400/10 last:border-b-0 ${
                  item.isClosed ? 'opacity-70' : ''
                }`}
              >
                <span
                  className="text-white font-semibold text-lg"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  {item.day}
                </span>
                <span
                  className="text-lg"
                  style={{
                    fontFamily: "'Montserrat', sans-serif",
                    color: item.isClosed ? 'rgba(255,255,255,0.6)' : '#FFFF00',
                    textShadow: item.isClosed ? 'none' : '0 0 10px rgba(255,255,0,0.5)',
                    fontWeight: item.isClosed ? 400 : 600,
                  }}
                >
                  {item.hours}
                </span>
              </div>
            ))}
          </div>

          <p
            className="text-center text-white/60 text-sm mt-4"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Feiertags ab 14:00 Uhr geöffnet. Bei schlechtem Wetter schaue bitte auf unserem Instagram <a href="https://www.instagram.com/saale_lounge?igsh=MXNtdWVoZHR5NjczNw==" target="_blank" rel="noopener noreferrer" className="text-yellow-400 hover:underline">@saale_lounge</a> vorbei.
          </p>
        </div>

        <div className="text-center mt-12 flex flex-wrap justify-center gap-4">
          <a
            href="#beach-events"
            className="inline-block px-8 py-3 rounded-full font-semibold transition-all duration-300"
            style={{
              background: '#FFD700',
              border: '2px solid #FFD700',
              color: '#0A0015',
              fontFamily: "'Montserrat', sans-serif",
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              fontSize: '0.875rem',
              boxShadow: '0 0 20px #FFD700'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'transparent';
              e.target.style.color = '#FFD700';
              e.target.style.boxShadow = '0 0 10px rgba(255, 215, 0, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#FFD700';
              e.target.style.color = '#0A0015';
              e.target.style.boxShadow = '0 0 20px #FFD700';
            }}>
            Events
          </a>
        </div>
      </div>
    </section>);

};

export default SaaleBeachSection;